import styled from 'styled-components';
import userIcon from './../../_static/icons/avatar0.png';
import logo from './../../_static/logo-white.png';

export const Header = styled.div`
        position: fixed;
        left: 0%;
        top: 0%;
        right: 0%;
        bottom: auto;
        z-index: 1000;
        width: 90%;
        height: 80px;
        //max-width: 960px;
        margin-right: auto;
        margin-left: auto;
        padding-top: 7px;
        padding-right: 60px;
        padding-left: 60px;
        border-bottom-left-radius: 80px;
        border-bottom-right-radius: 80px;
        background-color: #263f7a;
        box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.3);
        color: #fff;
        
        .logo {
            position: absolute;
            background: url(${logo}) center center no-repeat;        
            background-size: contain;
            height: 65px;
            min-width: 50px;
            top: 0;
            width: 170px;        
        }
        
        .brand-title {
            font-size: 25px;
            font-family: Lato, sans-serif;
            letter-spacing: -1px;
            font-weight: 300;
        }
        
        .nav-link:hover {
          background-color: #ffffff;
          color: black !important;
          -webkit-border-radius: 8px;
          -moz-border-radius: 8px;
          border-radius: 8px;
        }
        
        .vertical-divider {
            width: 1px;
            height: 40px;
            background-color: #bdbdbd;
        }
        
        .navbar-light .navbar-toggler {
            border-color: rgba(255, 255, 255, 1);
        }
        
 `;

export const Avatar = styled.div`
        position: fixed;
        left: auto;
        top: 0px;
        right: 0%;
        bottom: auto;
        z-index: 1000;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        width: 60px;
        height: 80px;
        padding: 10px 20px 10px 50px;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        -ms-flex-pack: end;
        justify-content: flex-end;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
       // border-radius: 0px 0px 0px 30px;
       // background-color: #263f7a;
       // box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.3);
        
        .user-img {
            background-color: #263f7a;
            background: url(${userIcon});
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            
            width: 50px;
            height: 50px;
            margin-right: 10px;
            float: right;
            border-style: none;
            border-width: 1px;
       //     border-color: #f0f;
            border-radius: 25px;
            cursor: pointer;
        }
        
        a {
            font-size: 1.2em;
            font-weight: bold;
        }       
        
      
        
        .navbar-light .navbar-nav .nav-link {
            color: #ffffff;
            font-size: 14px;
        }
        
              
        .link-text {
          color: black !important;
          font-size: 14px !important;
          padding-left: 25px !important;
        }
        
        
 `;

export const Body = styled.div`
    @media only screen and (max-width: 992px) { 
        display: none;
    }
`;